// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3-vTm","header":"ClearentDisclaimer_header__kQOzV","inner":"ClearentDisclaimer_inner__2Pc8i"};